export const subscriptionsApiEndpoints: Record<string, string> = {
  platformSubscriptions: "/ext/subscriptions/platform/",
  setSubscription: "PUT:/ext/subscriptions/platform/:pk/",
  decideSubscription: "POST:/ext/subscriptions/platform/requests/:pk/decide/",
  mySubscription: "/ext/subscriptions/mine/",
  askSubscription: "POST:/ext/subscriptions/mine/ask/",
  withdrawSubscription: "DELETE:/ext/subscriptions/mine/ask/",
  business: "/ext/subscriptions/business/",
  setBusiness: "PUT:/ext/subscriptions/business/",
};
